<template>
  <span class="stars">
    <svg
      v-for="star in 5"
      :key="star"
      class="star"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path v-if="star <= filled" :d="FILLED" fill="#fbcb41" />
      <path v-else :d="EMPTY" fill="#d9d9d9" />
    </svg>
  </span>
</template>

<script>
/**
 * COR-1684: the five stars of a workshop's feedback, as the design draws them
 * (Figma w5wqtsXqhRLkqFBhbr2vit, 26919:96319 filled / 26919:96323 empty).
 *
 * The glyph is the rounded Material star, taken path for path from the frame rather than
 * from `v-icon`, whose `star` is the sharper classic drawing. The frame paints the filled
 * star with a #fbba41 -> #fbe241 gradient; this is its flat midpoint, which no eye can
 * tell apart at 24px and keeps the markup to one path.
 *
 * No half star: the frames draw none, so a 4.4 average shows four.
 */
const FILLED =
  'M12 17.27L16.15 19.78C16.91 20.24 17.84 19.56 17.64 18.7L16.54 13.98L20.21 10.8C20.88 10.22 20.52 ' +
  '9.12 19.64 9.05L14.81 8.64L12.92 4.18C12.58 3.37 11.42 3.37 11.08 4.18L9.19 8.63L4.36 9.04C3.48 ' +
  '9.11 3.12 10.21 3.79 10.79L7.46 13.97L6.36 18.69C6.16 19.55 7.09 20.23 7.85 19.77L12 17.27Z'

const EMPTY =
  'M19.65 9.04L14.81 8.62L12.92 4.17C12.58 3.36 11.42 3.36 11.08 4.17L9.19 8.63L4.36 9.04C3.48 9.11 ' +
  '3.12 10.21 3.79 10.79L7.46 13.97L6.36 18.69C6.16 19.55 7.09 20.23 7.85 19.77L12 17.27L16.15 ' +
  '19.78C16.91 20.24 17.84 19.56 17.64 18.7L16.54 13.97L20.21 10.79C20.88 10.21 20.53 9.11 19.65 ' +
  '9.04ZM12 15.4L8.24 17.67L9.24 13.39L5.92 10.51L10.3 10.13L12 6.1L13.71 10.14L18.09 10.52L14.77 ' +
  '13.4L15.77 17.68L12 15.4Z'

export default {
  name: 'workshop-feedback-stars',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  data: () => ({ FILLED, EMPTY }),
  computed: {
    filled() {
      return Math.round(this.value)
    },
  },
}
</script>

<style scoped>
.stars {
  display: inline-flex;
  align-items: center;
}

.star {
  display: block;
}
</style>
